<template>
    <div class="video-control-wrapper"
         :class="{'interface-hidden': interfaceHidden}"
         @mousemove="handleMouseMove"
         @mouseleave="handleMouseMove"
    >
        <div v-show="!tab.current">

            <div id="playInfo" v-show="channel">
                <div>
                    <img :src="channel.icon">
                    <div class="channel">{{ channel.name }}</div>
                    <div class="programm" v-show="!isNaN(program.start) || !isNaN(program.end)">{{ time(program.start)}}&ndash;{{ time(program.end)}}. {{ program.name }}</div>
                </div>
            </div>

            <div id="videoControl" :style="{height: !isNaN(program.start) || !isNaN(program.end) ? '' : '46px'}">

                <div class="progress" :class="{'invisible': isNaN(program.start) || isNaN(program.end)}">
                    <vueSlider
                            v-model="progress"
                            tooltip="hover"
                            :lazy="true"
                            :process-style="{background:'#f98d0b'}" :slider-style="{boxShadow: 'none'}"
                            :bg-style="{borderRadius:'0'}"
                            :formatter="calcTimeline"
                            @callback="setProgress"
                            @drag-start="handleProgressBarDragStart"
                    ></vueSlider>
                </div>

                <div class="nav">
                    <a title="Каналы" @click.prevent="showTab('channels')" class="channellist"><i class="icon-menu"></i></a>
                    <!--a title="Видеотека" @click.prevent="showTab('vod')"><i class="icon-film"></i></a-->
                </div>
                <div class="controls">
                    <a v-show="playing" href="#" @click.prevent="pause"><i class="icon-control-pause"></i></a>
                    <a v-show="!playing" href="#" @click.prevent="play"><i class="icon-control-play"></i></a>

                    <a @wheel="handleVolumeWheel" href="#" @click.prevent="" class="controls_volume" @mouseover="$refs.volumeSlider.refresh()">
                        <i v-show="isMuted" @click="mute" class="icon-volume-off"></i>
                        <i v-show="!isMuted && volume <= 50" @click="mute" class="icon-volume-1"></i>
                        <i v-show="!isMuted && volume > 50" @click="mute" class="icon-volume-2"></i>
                        <div class="volume-slider">
                            <vueSlider ref="volumeSlider" :width="4" :height="100" :tooltip="false" v-model="volume" :process-style="{background:'#f98d0b'}" :slider-style="{boxShadow: 'none'}" :bg-style="{borderRadius:'0'}" direction="vertical"></vueSlider>
                        </div>
                        <span>Громкость {{volume}}%</span>
                    </a>
                    <div class="time" v-show="!isNaN(program.start) || !isNaN(program.end)">{{ time(program.start) }} / {{ time(program.end) }}</div>
                    <!--<span v-if="isLiveNow">LIVE</span>-->
                    <span v-if="(isLiveNow || (isNaN(program.start) || isNaN(program.end))) && playing">LIVE</span>
                    <span v-if="playing && $parent.mode === 'archive'" style="color:red;">R</span>
                    <span v-if="playing && $parent.mode === 'teleteka'" style="color:#2196F3;">T</span>
                    <span v-if="!playing">ПАУЗА</span>
                    <!--<span v-else class="notLiveLabel">LIVE</span>-->
                </div>
                <div class="nav right">
                    <Quality-select
                            v-show="!isNaN(program.start) || !isNaN(program.end)"
                            ref="qualitySelect"
                            :hls="hls"
                            :quality="quality"
                    ></Quality-select>
                    <label class="video-control_select-wrap select-format-wrap" v-show="!isNaN(program.start) || !isNaN(program.end)">
                        Формат:
                        <select class="video-control_select default-select" @change="changeVideoAspectRatio" :value="videoAspectRatio.index">
                            <!--<option value="-1">Авто</option>-->
                            <option v-for="(format, index) in videoAspectRatio.modes" :value="index" :key="index">{{format}}</option>
                        </select>
                        <!--<i class="icon-frame"></i>-->
                    </label>
                    <!--<a title="Сообщения" @click.prevent="showTab('messages')"><i class="icon-envelope"></i> <span v-show="newMessages">{{ newMessages }}</span></a>-->
                    <a title="Настройки" @click.prevent="showTab('settings')"><i class="icon-settings"></i></a>

                    <a href="#" title="Выйти" @click.prevent="logout"><i class="icon-power"></i></a>

                    <span>
                        <a v-if="!isInFullScreen" title="На весь экран" href="#" @click.prevent="fullScreen" class="fullscreen"><i class="icon-size-fullscreen"></i></a>
                        <a v-if="isInFullScreen" title="Выйти из полноэкранного режима" href="#" @click.prevent="fullScreen" class="fullscreen"><i class="icon-size-actual"></i></a>
                    </span>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
    import vueSlider from 'vue-slider-component'
    import QualitySelect from './QualitySelect.vue';

    import {mapState, mapActions} from 'vuex'

    export default {
        props: ['hls', 'loadingVideo'],
        components: {
            vueSlider,
            QualitySelect
        },
        data() {
            return {
                interfaceHidden: false,
                interfaceHiddenTimer: null,
                progress: 0,
                progressStartTime: 0,  // Время метка от которого идет отсчет прогресса воспроизведения в сек с 1970 года
                progressShift: 0, // Время смещения выбранного пользователем прогресса в сек с 1970 года, в лайве может совпадать с progressStartTime, но в архиве отличается
                progressTimer: null,
                epgStart: null,
                epgEnd: null,
                playing: true,
                isLiveNow: true,
                volume: 100,
                prevVolume: 100,
                isMuted: false,
                isInFullScreen: false
            }
        },
        computed: {
            ...mapState({
                channelsAspectRatio: state => state.channels.channelsAspectRatio,
                videoAspectRatio: state => state.videoAspectRatio.object,
                channel: state => state.channels.currentChannel,
                program: state => state.epg.currentProgram,
                newMessages: state => state.messages.messageCount,
                quality: state => state.videoOptions.object.quality,
                player: state => state.channels.player,
                tab: state => state.tab.tab,
                timeshiftValue: state => state.login.account.settings.timeshift.value
            }),
        },
        methods: {
            ...mapActions([
                'setVideoAspectRatio',
                'changeVideoAspectRatioIndex',
                'showToast',
                'showTab'
            ]),
            changeVideoAspectRatio(event) {
                this.changeVideoAspectRatioIndex(event.target.value);

                this.setVideoAspectRatio({
                    videoAspectRatio: this.videoAspectRatio, 
                    channelId: this.channel.id
                })
                    .then(() => {
                        this.showToast({
                            message: this.videoAspectRatio.modes[this.videoAspectRatio.index],
                            theme: 'success'
                        });
                    });
            },
            handleMouseMove(e) {
                this.interfaceHidden = false;
                clearTimeout(this.interfaceHiddenTimer);

                let importantElement;

                if (e.path) {
                    importantElement = e.path.find(elem => {
                        return (elem.getAttribute && (elem.getAttribute('id') === 'videoControl' || elem.getAttribute('id') === 'playInfo'))
                    });
                }
                else {
                    importantElement = (e.target.getAttribute('id') === 'videoControl' || e.target.getAttribute('id') === 'playInfo' || e.target.closest('#videoControl') || e.target.closest('#playInfo'));
                }


                if (!importantElement) {
                    this.interfaceHiddenTimer = setTimeout(() => {
                        this.interfaceHidden = true;
                    }, 4000);
                }
            },
            handleVolumeWheel(e) {
                if (e.deltaY < 0) {
                    if (this.volume < 100) {
                        this.volume = this.volume + 5;
                    }
                }
                else {
                    if (this.volume > 0) {
                        this.volume = this.volume - 5;
                    }
                }
            },
            mute() {
                this.isMuted = !this.isMuted;
                if (this.isMuted) {
                    this.prevVolume = this.volume;
                    this.volume = 0;
                }
                else {
                    this.volume = this.prevVolume;
                }
            },
            initShortcuts() {
                document.body.onkeyup = e => {
                    if (e.keyCode == 32 && !this.$parent.tab.current) {
                        if (this.playing) {
                            this.pause();
                        }
                        else {
                            this.play();
                        }
                    }
                }
            },
            handleProgressBarDragStart() {
                clearInterval(this.progressTimer);
            },
            logout() {
                this.$emit('getLogout');
            },
            // Метод для подсчета текущего прогресса (позиции ползунка) воспроизведения, бежит переодически чтобы прогресс двигался согласно текущему времени
            calcProgress() {
                let timeshiftValue = +this.timeshiftValue * 60 * 60 * 1000;

                let now = Math.trunc((Date.now() - timeshiftValue) / 1000);
                let newShift = now - +this.progressStartTime;
                let temp;

                if (this.$parent.mode === 'teleteka') {
                    temp = this.player.currentTime / this.program.duration;
                }
                else {
                    temp = ((newShift + +this.progressShift) - +this.program.start) / (+this.program.end - +this.program.start);
                }

                this.progress = Math.trunc(temp * 100);

                if (this.progress >= 100) {
                    this.$parent.apiGetChannelList(
                        null,
                        null,
                        false,
                        () => this.$parent.mode !== 'teleteka' && this.$emit('updateProgramInfo')
                    );
                }
            },
            // Прогресс после запуска канала
            setLiveProgress() {
                let timeshiftValue = +this.timeshiftValue * 60 * 60 * 1000;

                this.progressStartTime = Math.trunc((Date.now() - timeshiftValue) / 1000);
                this.progressShift = Math.trunc((Date.now() - timeshiftValue) / 1000); // время смещенного просмотра в сек, по умолчанию текущее время (live), то есть время которое выбрал человек в сек с 1970 года

                this.progress = Math.trunc((this.progressStartTime - this.channel.epg_start) / (this.channel.epg_end - this.channel.epg_start) * 100);

                this.startProgressTimer();

                this.isLiveNow = true;
                this.$parent.mode = 'live';
            },
            calcTimeline(value) {
                if (this.$parent.mode === 'teleteka') {
                    if (isNaN(value)) return '--:--';
                    return `${value}%`;
                }
                else {
                    let time = Math.trunc(+this.program.start + (+this.program.end - +this.program.start) / 100 * value);
                    if (isNaN(time)) return '--:--';
                    return this.time(time);
                }
            },
            setProgressToStart(utcStart) {
                let timeshiftValue = +this.timeshiftValue * 60 * 60 * 1000;

                this.progress = 0;
                this.progressStartTime = Math.trunc((Date.now() - timeshiftValue) / 1000);
                this.progressShift = +utcStart;

                this.isLiveNow = false;
                this.startProgressTimer();
            },
            // Установка прогресса пользователем при изменение на прогресс-баре
            setProgress(value) {
                let timeshiftValue = +this.timeshiftValue * 60 * 60 * 1000;

                if (this.$parent.mode === 'teleteka') {
                    clearInterval(this.progressTimer);
                    this.progress = value;
                    this.setCustomProgress();

                    if (this.playing) {
                        setTimeout(() => {
                            this.startProgressTimer();
                        }, 500);
                    }
                }
                else {
                    let now = Math.trunc((Date.now() - timeshiftValue) / 1000);

                    if (now > this.program.start && now < this.program.end) {
                        let livePosition = Math.trunc((now - this.channel.epg_start) / (this.channel.epg_end - this.channel.epg_start) * 100);

                        if (value < livePosition) {
                            this.progress = value;
                            this.setCustomProgress();
                        }
                        else {
                            this.setLiveProgress();
                            this.$parent.apiGetUrl();
                            this.calcProgress();
                        }
                    }
                    else {
                        this.progress = value;
                        this.setCustomProgress();
                    }
                    this.startProgressTimer();
                }
            },
            setCustomProgress() {
                let timeshiftValue = +this.timeshiftValue * 60 * 60 * 1000;

                if (this.$parent.mode === 'teleteka') {
                    let percent = this.program.duration / 100;
                    let shift = percent * this.progress;

                    this.progressStartTime = Math.trunc((Date.now() - timeshiftValue) / 1000);
                    this.progressShift = (percent * this.progress) + this.program.start;

                    this.player.currentTime = shift;
                }
                else {
                    let percent = (this.program.end - this.program.start) / 100;
                    let shift = (percent * this.progress) + this.program.start;
                    this.progressStartTime = Math.trunc((Date.now() - timeshiftValue) / 1000);
                    this.progressShift = shift;
                    this.$parent.apiGetUrl(null, shift);

                    if (this.isLiveNow) {
                        this.$emit('saveCurrentProgramToArchiveInfo', this.program);
                    }

                    this.isLiveNow = false;
                    this.$parent.mode = 'archive';
                }
            },
            startProgressTimer() {
                clearInterval(this.progressTimer);
                this.progressTimer = window.setInterval(() => {
                    this.calcProgress();
                }, 2000);
            },
            pause() {
                clearInterval(this.progressTimer);
                this.playing = false;
                this.player.pause();

                if (this.isLiveNow) {
                    this.$emit('saveCurrentProgramToArchiveInfo', this.program);

                    this.isLiveNow = false;
                    this.$parent.mode = 'archive';
                }
            },
            play() {
                if (this.$parent.mode !== 'teleteka') this.resumeWatching();
                this.startProgressTimer();
                this.playing = true;
                this.player.play();
            },
            resumeWatching() {
                let timeshiftValue = +this.timeshiftValue * 60 * 60 * 1000;

                let percent = (this.program.end - this.program.start) / 100;
                let shift = (percent * this.progress) + this.program.start;

                let diff = (Date.now() - timeshiftValue) / 1000 - shift;

                if (diff > 30) {
                    this.progressStartTime = Math.trunc((Date.now() - timeshiftValue) / 1000);
                    this.progressShift = shift;
                    this.$parent.apiGetUrl(null, shift);
                }
                else {
                    this.$emit('saveCurrentProgramToArchiveInfo', null);
                    this.setLiveProgress();
                }
            },
            fullScreen() {
                if (this.isInFullScreen) {
                    this.isInFullScreen = false;
                    if (document.exitFullscreen) document.exitFullscreen();
                    else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
                    else if (document.mozCancelFullScreen) document.mozCancelFullScreen();
                    else if (document.msExitFullscreen) document.msExitFullscreen();
                }
                else {
                    this.isInFullScreen = true;
                    let elem = document.documentElement;
                    if (elem.requestFullscreen) elem.requestFullscreen();
                    else if (elem.webkitRequestFullScreen) elem.webkitRequestFullScreen();
                    else if (elem.mozRequestFullScreen) elem.mozRequestFullScreen();
                    else if (elem.msRequestFullscreen) elem.msRequestFullscreen();
                }
            },
            time(v) {
                let time = new Date(v * 1000);
                return time.getHours() + ':' + ((time.getMinutes() < 10) ? '0' + time.getMinutes() : time.getMinutes());
            },
        },
        watch: {
            volume(value) {
                if (value === 0) this.isMuted = true;
                else {
                    this.isMuted = false;
                    this.player.volume = value / 100;
                }
            },
            isMuted(isMuted) {
                this.player.muted = isMuted;
            },
            loadingVideo() {
                if (this.player) this.player.muted = this.isMuted;

                if (!this.playing || this.player.paused) this.pause();
            }
        },
        created() {
            this.initShortcuts();
        }
    }
</script>
<style>
    .video-control-wrapper {
        height: 100%;
        width: 100%;
        position: absolute;
        top: 0;
    }

    .interface-hidden {
        cursor: none;
    }

    #playInfo {
        position: absolute;
        z-index: 999;
        top: 0;
        left: 0;
        width: 100%;
        /*min-height: 120px;*/
        background: linear-gradient(to top, rgba(0, 0, 0, 0), rgba(0, 0, 0, .8));
        transition: opacity .25s;
    }

    .interface-hidden #playInfo {
        opacity: 0;
    }

    #playInfo > div {
        /*background: transparent no-repeat 0 10px;*/
        /*background-size: 90px;*/
        /*padding: 16px 8px 0 100px;*/
        padding: 16px 10px 10px 10px;
    }

    #playInfo > div:after {
        display: block;
        clear: both;
        content: '';
    }

    #playInfo .channel {
        font-size: 28px;
        line-height: 28px;
        padding-left: 100px;
    }

    #playInfo .programm {
        font-size: 14px;
        /*white-space: nowrap;*/
        /*text-overflow: ellipsis;*/
        width: 100%;
        /*overflow: hidden;*/
        padding-left: 100px;
        box-sizing: border-box;
    }

    /*#playInfo .programm:hover {*/
    /*white-space: normal;*/
    /*}*/

    #playInfo img {
        /* display: inline-block; */
        float: left;
        width: 90px;
        /* vertical-align: unset; */
        margin-top: -7px;
    }

    #videoControl {
        position: fixed;
        z-index: 999;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 76px;
        background: rgba(0, 0, 0, .75);
        transition: bottom, opacity .25s;
    }

    .interface-hidden #videoControl {
        opacity: 0;
    }

    /*.loading #videoControl {*/
        /*bottom: -120px;*/
    /*}*/

    .loading #videoControl .progress {
        opacity: 0;
        pointer-events: none;
    }

    #videoControl .nav {
        float: left;
        border-right: solid 1px rgba(255, 255, 255, .2);
    }

    #videoControl .nav.right {
        float: right;
        border-right: 0;
        border-left: solid 1px rgba(255, 255, 255, .2);
    }

    #videoControl .nav a, #videoControl .controls a, #videoControl .controls > div {
        display: inline-block;
        padding: 12px;
        line-height: 13px;
        margin: 0;
        min-width: 15px;
        height: 13px;
        text-align: center;
        color: #fff;
        text-decoration: none;
        white-space: nowrap;
    }

    #videoControl .controls {
        float: left;
    }

    #videoControl .controls a > span {
        /*display: none*/
        width: 0px;
        display: inline-block;
        overflow: hidden;
        transition: width .2s;
        height: 15px;
        line-height: 14px;
    }

    #videoControl .controls a:hover > span,
    #videoControl .controls a:active > span {
        width: 130px;
    }

    #videoControl .channel > div {
        padding: 0 10px 0 110px;
        border: 0;
    }

    #videoControl .channel .programm {
        min-height: 14px;
        height: 14px;
    }

    #videoControl .controls a {
        border: 0;
    }

    #videoControl .vue-slider-wrap {
        padding: 0 !important;
    }

    #videoControl .progress {
        cursor: pointer;
    }

    #videoControl .progress.invisible {
        opacity: 0;
        height: 0;
        pointer-events: none;
    }

    .controls_volume {
        position: relative;
    }

    .controls_volume .volume-slider {
        opacity: 0;
        pointer-events: none;
        position: absolute;
        bottom: 30px;
        left: 5px;
        z-index: 9;
        background: #0e0e0e;
        padding: 5px;
        padding-bottom: 0px;
        transition: opacity .1s;
        border-radius: 4px;
    }

    a.controls_volume:hover > .volume-slider,
    a.controls_volume:active > .volume-slider {
        opacity: 1;
        pointer-events: auto;
    }

    .notLiveLabel {
        color: #505050;
        cursor: pointer;
    }

    .notLiveLabel:hover {
        color: #ffffff;
    }

    .select-format-wrap {
        position: relative;
        margin-left: 10px;
    }

    .video-control_select {
        width: auto;
        /*margin: 0px 5px;*/
        margin: 0px;
        font-size: 15px;
    }

    .video-control_select-wrap {
        margin: 0px 10px;
    }
</style>



// WEBPACK FOOTER //
// VideoControl.vue?5bf9b06b